export default __webpack_public_path__ + "static/media/processing.bcdd6e46.JPG";